import { Grommet } from "grommet";
import { grommet } from "grommet/themes";
import { deepMerge } from "grommet/utils";
import React, { useEffect, useState } from "react";
import ContactForm from "../pages/contact";
import { theme } from "../theme";

const customTheme = deepMerge(grommet, theme);

function FullForm() {

  return (
    <Grommet theme={customTheme} background="transparent">
      <ContactForm />
    </Grommet>
  );
}

export default FullForm;
